import { MontadorOperacao } from "@/components/canvas/MontadorOperacao";
import { ComSlotAcoes } from "@/components/layout/SlotAcoes";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { TipoNo } from "@/types";

const PAPEIS: TipoNo[] = ["PRODUTOR", "ECE", "DISTFS", "ARMAZEM", "DISTRIBUIDORA", "EXTERIOR"];

/*
  As três sub-abas usam o mesmo contexto — as regras da usina — e mudam só o
  fluxo-modelo de partida. Venda à ordem não entra: a remessa por conta e ordem
  só existe nas regras da ECE.
*/
export function VendasProdutoraPage() {
  return (
    <div className="space-y-5">
      <Tabs defaultValue="venda">
        <ComSlotAcoes
          abas={
            <TabsList>
              <TabsTrigger value="venda">Venda</TabsTrigger>
              <TabsTrigger value="armazenagem">Armazenagem</TabsTrigger>
              <TabsTrigger value="exportacao">Exportação</TabsTrigger>
            </TabsList>
          }
        >
          <TabsContent value="venda">
            <MontadorOperacao
              contexto="produtora"
              chaveModelo="produtora"
              variante="venda"
              titulo="Venda"
              descricao="Venda de EAC (diferida) e de EHC (tributada na saída) para ECE ou distribuidora, e transferências entre estabelecimentos."
              papeis={PAPEIS}
              produtos={["anidro", "hidratado"]}
            />
          </TabsContent>

          <TabsContent value="armazenagem">
            <MontadorOperacao
              contexto="produtora"
              chaveModelo="produtora_armazenagem"
              variante="armazenagem"
              titulo="Armazenagem"
              descricao="Remessa da usina para armazém-geral ou depósito — não incidência na interna, suspensão do EAC."
              papeis={PAPEIS}
              produtos={["anidro", "hidratado"]}
            />
          </TabsContent>

          <TabsContent value="exportacao">
            <MontadorOperacao
              contexto="produtora"
              chaveModelo="produtora_exportacao"
              variante="exportacao"
              titulo="Exportação"
              descricao="Exportação direta pela usina ao cliente no exterior."
              papeis={PAPEIS}
              produtos={["anidro", "hidratado"]}
            />
          </TabsContent>
        </ComSlotAcoes>
      </Tabs>
    </div>
  );
}
